import React, { useState } from 'react';
import { CardAnalytics } from '../../../components/library/card-analytics/CardAnalytics';
import { useAppDispatch, useAppSelector } from '../../../contexts/hooks';
import { EReportId } from '../../../types/types.dashboard';
import { useApiDashBoard } from '../../../api/api.dashboards';
import { FilteredOrders, ResultEstadoResult } from '../../../types/types.orders';
import { setFilteresToOrders } from '../../../contexts/slices/orders';
import { ConvertLocalDate } from '../../../utils/functions';
import { LoadIndicator } from 'devextreme-react';
import { useNavigate } from 'react-router-dom';
import './PpalBoard.scss';

interface PpalBoardCard {
  id: string;
  title: string;
  count: number;
  description: string;
  color: string;
  icon: string;
  estadoFiltro: ResultEstadoResult[];
}

export const BoardPpal = () => {
  const { getData } = useApiDashBoard();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loadingCardId, setLoadingCardId] = useState<string | null>(null);
  const dashboard = useAppSelector((x) => x.dashboards.dashboards.find((x) => x.Db_Id === EReportId.PpalBoard));

  if (!dashboard) {
    return <CardAnalytics title='Tablero Principal' contentClass='sales' />;
  }

  const handleRefreshClick = () => {
    getData(EReportId.PpalBoard);
  };

  const handleCardClick = (estados: ResultEstadoResult[], cardId: string) => {
    const today = ConvertLocalDate(new Date());
    const filters: FilteredOrders = {
      Servicios: [],
      Fechas: [today, today],
      Areas: [],
      Estudios: [],
      Estados: estados,
      Redirect: true,
    };
    setLoadingCardId(cardId);
    dispatch(setFilteresToOrders(filters));
    navigate('/admin-orders'); // Sin state, preserva el tab actual del usuario
  };

  // Datos de ejemplo - en un caso real vendrían del dashboard.Data
  const cardsData: PpalBoardCard[] = [
    {
      id: 'total-ordenes',
      title: 'Total órdenes',
      count: dashboard.Data?.[0].TotalOrdenes || 0,
      description: 'Total pacientes ingresados',
      color: '#007bff',
      icon: 'group',
      estadoFiltro: [], // Sin filtro de estado - todas las órdenes
    },
    {
      id: 'pendientes',
      title: 'Pendientes',
      count: dashboard.Data?.[0].Ingresadas || 0,
      description: 'Órdenes sin resultados',
      color: '#ffc107',
      icon: 'clock',
      estadoFiltro: [ResultEstadoResult.SinResultado], // Estado pendiente
    },
    {
      id: 'sin-validar',
      title: 'Sin Validar',
      count: dashboard.Data?.[0].ConResultados || 0,
      description: 'Órdenes con resultados pero no validados',
      color: '#fd7e14',
      icon: 'warning',
      estadoFiltro: [ResultEstadoResult.ConResultado], // Estado con resultados sin validar
    },
    {
      id: 'validados',
      title: 'Validados',
      count: dashboard.Data?.[0].Validadas || 0,
      description: 'Órdenes validadas',
      color: '#28a745',
      icon: 'check',
      estadoFiltro: [ResultEstadoResult.Validado, ResultEstadoResult.Impreso, ResultEstadoResult.OtrasFuentes], // Estado validado
    },
  ];

  return (
    <CardAnalytics title='Tablero Principal' contentClass='ppal-board' isLoading={dashboard.Loading} onRefreshClick={handleRefreshClick} lastUpdate={dashboard.UltimaActualizacion}>
      <div className='ppal-board-container'>
        <div className='ppal-board-grid'>
          {cardsData.map((card) => (
            <div key={card.id} className={`ppal-board-card ${loadingCardId === card.id ? 'loading' : ''}`} onClick={() => handleCardClick(card.estadoFiltro, card.id)} style={{ '--card-color': card.color } as React.CSSProperties}>
              {/* LoadIndicator superpuesto */}
              {loadingCardId === card.id && (
                <div className='card-loading-overlay'>
                  <LoadIndicator width={24} height={24} />
                </div>
              )}

              <div className='card-header'>
                <div className='card-icon'>{loadingCardId === card.id ? <i className='dx-icon-loading' style={{ animation: 'spin 1s linear infinite' }} /> : <i className={`dx-icon-${card.icon}`} />}</div>
                <div className='card-count'>{card.count.toLocaleString()}</div>
              </div>
              <div className='card-content'>
                <div className='card-title'>{card.title}</div>
                <div className='card-description'>{card.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </CardAnalytics>
  );
};
